var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          Object.keys(_vm.records).length
            ? _c("table", { staticClass: "table mt-1 table-sm table-hover" }, [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "tbody",
                  [
                    _vm._l(_vm.records, function (sD, storeId) {
                      return [
                        _c("tr", { staticClass: "store_title" }, [
                          _c("td", { attrs: { colspan: "10" } }, [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.$AllStores[storeId]?.title)),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.getSortedRecords(sD), function (r) {
                          return _c(
                            "tr",
                            {
                              class: {
                                green_line:
                                  (_vm.storeData?.inStores?.[r.drug_id]?.[3] ??
                                    0) >
                                  r.total_qty + 10,
                              },
                            },
                            [
                              _c("td", [_vm._v(_vm._s(r.drug_id))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(r.title))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(r.total_orders))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(r.total_sum))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(r.total_qty))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.storeData?.inStores?.[r.drug_id]?.[3] ??
                                      0
                                  )
                                ),
                              ]),
                            ]
                          )
                        }),
                      ]
                    }),
                  ],
                  2
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Полезный склад")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Заявок")]),
        _vm._v(" "),
        _c("th", [_vm._v("На сумму")]),
        _vm._v(" "),
        _c("th", [_vm._v("Кол.Пр.")]),
        _vm._v(" "),
        _c("th", [_vm._v("На складе")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }